import script from "./S3Form.vue?vue&type=script&setup=true&lang=js"
export * from "./S3Form.vue?vue&type=script&setup=true&lang=js"

import "./S3Form.vue?vue&type=style&index=0&id=57d4fb27&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d4fb27"]])

export default __exports__